// removed by extract-text-webpack-plugin
module.exports = {"affiliate-name":"main_nav-BXG","wrapper":"main_nav-1X4","section":"main_nav-3jG","container":"main_nav-3Dv","contact-info":"main_nav-3ZB","text":"main_nav-1pV","plus":"main_nav-3An","logo":"main_nav-3a_","nav":"main_nav-Z5g"};


//////////////////
// WEBPACK FOOTER
// ../src/templates/MainNav/AffiliateNav/affiliate_nav.module.scss
// module id = 350
// module chunks = 0